import RequestApi from "../../modules/requestApi";
import moment from "moment";

const state = {
  // список хотспотов
  hotspotList: [],
  // признак что список грузится
  hotspotIsPending: false,
  // признак что список заружен
  hotspotIsLoaded: false,
  // таймер после смены названия сети хотспота
  timerHotspot: {}
};

const mutations = {
  // список хотспотов
  SET_HOTSPOT_LIST(state, data) {
    // сортируем по id
    state.hotspotList = data.sort((a, b) =>
      a.id > b.id ? 1 : b.id > a.id ? -1 : 0
    );
  },
  // записывает в объект хотспота, прикрепленную тему
  SET_HOTSPOT_ITEM(state, data) {
    // определяем индекс по id
    const index = state.hotspotList.findIndex(item => item.id === data.id);
    if (index !== -1) {
      // перезаписываем элемент, через удаление, иначе реактивность не срабатывает
      state.hotspotList.splice(index, 1, {
        ...state.hotspotList[index],
        ...data
      });
    }
  },
  // признак что список грузится
  SET_HOTSPOT_IS_PENDING(state, data) {
    state.hotspotIsPending = data;
  },
  // признак что список заружен
  SET_HOTSPOT_IS_LOADED(state, data) {
    state.hotspotIsLoaded = data;
  },
  // запуск таймера
  SET_HOTSPOT_TIMER(state, data) {
    const index = state.hotspotList.filter(item => item.id === data.id);
    if (index) {
      state.timerHotspot = {
        ...state.timerHotspot,
        [data.id]: {
          hotspotId: data.id,
          isActive: data.isActive,
          startTime: data.startTime,
          stopTime: data.stopTime,
          timerMikrotik: data.timerMikrotik
        }
      };
    }
  },
  // удаляет таймер после его завершения
  DEL_HOTSPOT_TIMER(state, data) {
    const index = state.hotspotList.filter(item => item.id === data);
    if (index) {
      delete state.timerHotspot[data];
    }
  }
};

const actions = {
  /**
   * Загрузка данных по списку хотспотов
   */
  hotspotListLoad({ commit, state, dispatch }) {
    // если список не загружен и не на стадии загрузки
    if (!state.hotspotIsLoaded && !state.hotspotIsPending) {
      // список загружается
      commit("SET_HOTSPOT_IS_PENDING", true);
      return new Promise((resolve, reject) => {
        RequestApi.hotspotList()
          .then(async data => {
            for (var i = 0; i < data.length; i++) {
              data[i]["sms"] = {
                ...(await dispatch(
                  "getHotspotSMSCount",
                  data[i].cl_service_id
                )),
                ...(await dispatch("getSMSCount", data[i].cl_service_id))
              };
              data[i]["sms"].balance =
                data[i].sms.smsTotal - data[i].sms.cntMonth;
            }
            commit("SET_HOTSPOT_LIST", data);
            commit("SET_HOTSPOT_IS_PENDING", false);
            commit("SET_HOTSPOT_IS_LOADED", true);
            resolve(data);
          })
          .catch(reject);
      });
    }
  },

  /**
   * Определение темы хотспота
   * id  - id хотспота
   */
  getHotspotTheme({ commit, state }, id) {
    let theme = {};
    return new Promise((resolve, reject) => {
      RequestApi.hotspotTheme({ hotspot_id: id })
        .then(data => {
          if (data) {
            theme = state.getters.getTheme(data.theme_id);
            commit("SET_HOTSPOT_ITEM", id, { theme: theme });
          }
        })
        .catch(reject);
    });
  },
  /**
   * Запрос одного хотспота по id
   */
  getHotspot({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.hotspotGet(params)
        .then(data => {
          commit("SET_HOTSPOT_ITEM", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  /**
   * Редактирование хотспота
   */
  editHotspot({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.hotspotEdit(params)
        .then(data => {
          commit("SET_HOTSPOT_ITEM", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  /**
   * Редактирование настроек wifi сети хотспота
   */
  editHotspotWifi({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.hotspotWifiEdit(params)
        .then(() => {
          // изменения в базе производит ЕСС, поэтому делаем доп. запрос к базе
          setTimeout(() => {
            dispatch("getHotspot", { id: params.id }).then(data => {
              resolve(data);
            });
          }, 1000);

          // запускает таймер после изменения параметров
          dispatch("runTimer", { id: params.id, timerMikrotik: 60 });
        })
        .catch(reject);
    });
  },
  /**
   * Запуск таймера после изменения названия сети/пароля
   */
  runTimer({ commit, dispatch, getters }, params) {
    // если таймера нет, то создаем новый
    if (!getters.timerHotspot[params.id]) {
      let startTime = Date.now(),
        stopTime = Date.now() + params.timerMikrotik * 1000;
      commit("SET_HOTSPOT_TIMER", {
        id: params.id,
        isActive: true,
        stopTime: stopTime,
        startTime: startTime,
        timerMikrotik: params.timerMikrotik - 1
      });
      dispatch("runTimer", params);
    } else {
      // если таймер есть и время еще не вышло
      if (
        getters.timerHotspot[params.id].timerMikrotik > 0 &&
        getters.timerHotspot[params.id].stopTime > Date.now()
      ) {
        setTimeout(() => {
          commit("SET_HOTSPOT_TIMER", {
            id: params.id,
            isActive: true,
            stopTime: getters.timerHotspot[params.id].stopTime,
            startTime: getters.timerHotspot[params.id].startTime,
            timerMikrotik: Math.floor(
              (getters.timerHotspot[params.id].stopTime - Date.now()) / 1000
            )
          });
          dispatch("runTimer", params);
        }, 1000);
      } else {
        commit("DEL_HOTSPOT_TIMER", params.id);
      }
    }
  },
  /**
   * Получение различных групп смс в тарифе хотспота
   * group_id = 36 - функция с пакетом смс
   */
  getHotspotSMSCount({ getters }, serviceId) {
    let sms = { priceMoreCount: 0, smsTotal: 0 };
    // массив для поиска содержимого тарифа
    let tariffArray = [];
    if (getters.user.tariff_info) {
      tariffArray = getters.user.tariff_info.find(
        value => +value.cl_service_id === serviceId
      );
      if (tariffArray && tariffArray.func_info.length) {
        // массив с объектом(-ами) функции с пакетом смс
        let funcArray = tariffArray.func_info.filter(
          value => +value.group_id === 36
        );
        sms.smsTotal = funcArray
          .map(value => +value.count_elements)
          .reduce(function(sum, current) {
            return sum + current;
          });
        sms.priceMoreCount = Math.min.apply(
          null,
          funcArray.map(value => +value.price_more_count)
        );
      }
    }
    return sms;
  },

  /**
   * Запрос подсчета по смс
   */
  async getSMSCount({ getters }, serviceId) {
    let sms = { cntMonth: 0, sumOverLimit: 0 };
    try {
      const data = await RequestApi.getSMSCount({
        clientId: getters.user.client_id,
        serviceId: +serviceId,
        month: moment().format("M"),
        year: moment().format("YYYY")
      });
      sms.cntMonth = +data.map(item => item.cnt_month);
      sms.sumOverLimit = +data.map(item => item.sum_over_limit);
      return Promise.resolve(sms);
    } catch (error) {
      this.error = error;
      return Promise.reject(error);
    }
  }
};

const getters = {
  // список хотспотов
  // ids - массив - фильтр по id
  hotspotList: state => {
    return state.hotspotList;
  },
  // объект с hotspot по id
  getHotspot: state => id => {
    return state.hotspotList.find(item => item.id === id);
  },
  // признак что список грузится
  hotspotIsPending: state => {
    return state.hotspotIsPending;
  },
  // признак что список заружен
  hotspotIsLoaded: state => {
    return state.hotspotIsLoaded;
  },
  // таймер после смены названия сети
  timerHotspot: state => {
    return state.timerHotspot;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
